import React from 'react';
import BooleanInput from '../Form/BooleanInput';
import FormInput from '../Form/FormInput';
import StringSelector from '../Form/StringSelector';
import { Container, Row, Col } from 'reactstrap';
import { FormLabel } from '../Form/FormLabel';
import { useAuth } from '../../Services/AuthContext';
import { useFetchCached } from '../../Services/fetchApi';
import { endpoints } from '../../utils/Constants';

const ClientDetail = ({ invite }) => {
    const [auth] = useAuth();
    const [clientTypes] = useFetchCached(auth.role === 'Admin' ? endpoints.getClientTypes : null);
    const clientTypeList = clientTypes?.map(x => x.name) || [];
    return <React.Fragment>
        <Container>
            <Row>
                <Col>
                    <Row>
                        <Col>
                            <FormInput id='companyName' label='Company Name' />
                        </Col>
                        <Col>
                            <FormInput id='companyAddress' label='Company Address' />
                        </Col>
                        <Col>
                            <FormInput id='companyPhone' label='Company Phone' type='phone' />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormInput id='firstName' label='First Name' />
                        </Col>
                        <Col>
                            <FormInput id='lastName' label='Last Name' />
                        </Col>
                        <Col>
                            <FormInput readOnly={!invite} id='email' label='Email' type='email' />
                        </Col>
                    </Row>

                </Col>
            </Row>
            <Row>
                <Col>
                    <FormInput id='notesForSupplier' label='Notes For Supplier' type='textarea' />
                </Col>
            </Row>
            {auth.role === "Admin" ? <Row>

                <Col>
                    <BooleanInput id='canViewSupplierInfo' label='Can View Supplier Info?' />
                </Col>
                <Col>
                    <BooleanInput id='hidePrice' label='Hide Price?' />
                </Col>

                <Col>
                    <StringSelector id='clientType' hideAllButton label="Client Type" isMulti stringType list={clientTypeList} />
                </Col>
                <Col>
                    <BooleanInput id='bypassesAdminApproval' label='Bypass Admin Approval for Charter Requests?' />
                </Col>          
            </Row> : null}
            <Row>
                <Col>
                    <FormLabel>Itinerary Settings</FormLabel>
                </Col>
            </Row>
            <Row>
                <Col>
                    <BooleanInput id='itineraryShowPrice' label='Show price in itinerary?' />
                </Col>
                 <Col>
                    <FormInput id='itineraryMinutesOffset' label="Itinerary Departure Time offset" type='number' />
                </Col>
                <Col>
                    <BooleanInput id='itineraryHidePhone' label='Hide Passenger phone numbers?' />
                </Col>
                <Col>
                    <BooleanInput id='itineraryShowSupplier' label='Show Supplier details in itinerary?' />
                </Col>
            </Row>                     

        </Container>

    </React.Fragment>
};

export default ClientDetail;




